import { WEB_URL } from "@/config/endpoints"
import IMAGES from "@/public/assets/img";


export default {
  SeoContent:{
        title: 'Global Supply Chain Finance Company | Innovative Solution',
        url:  WEB_URL+'/en-us/interest-calculator',
        name:'description',
        description:'Credlix is a digital Global Supply Chain Finance Company from Moglix that provides quick, collateral-free working capital solutions for the entire supply chain.',
        keyword: 'supply chain finance, supply chain finance, supply chain in finance,supply chain finance company', 
        imagePath:IMAGES.HOMEIMG.bigLogoNew.src
    },
    CalcIndia:false,
    Calc:{
      leftHeading:'The best price for <br className="sm:hidden md:hidden xm:hidden"/> Export Financing',
      whyCalculate:[
        "Lowest<strong> Factoring Fee</strong>",
        "<strong> Up to 90% </strong> disbursement",
        "Desembolso <strong>rápido</strong>"
      ],
      heading2:'Calculate cost per invoice',
      principalAmt:'Invoice amount (in $)',
      tenor:'Tenor (in days)',
      rightHeading:'Fastest growing and one of the largest export factoring companies in USA.',
      competitionHead:'Competition',
      totAmt:'Invoice amount',
      fundAmt:'Financing amount (80% financing)',
      factorText:'Factoring fee/per month @',
      edit:'Edit',
      applicable:'(Applicable to the financing amount, i.e. 80%)',
      totalText:'Total Fees',
      fundAmtCredlix:'Financing amount (90% financing)',
      applicableCred:'(Applied on the actual financing amount, i.e. 90%)',
      annAmt:'Annual savings',
      note:"Our promise: If you get a better price, we'll match it.",
      ctaName:'Start now',
      days:'days',
    }
}